/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeactivateLicenseRequestEntity = {
  /**
   * The license key to deactivate.
   */
  key: string;
  /**
   * Id of the instance to deactivate.
   */
  instanceId: string;
};

/** @internal */
export const DeactivateLicenseRequestEntity$inboundSchema: z.ZodType<
  DeactivateLicenseRequestEntity,
  z.ZodTypeDef,
  unknown
> = z.object({
  key: z.string(),
  instance_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "instance_id": "instanceId",
  });
});
/** @internal */
export type DeactivateLicenseRequestEntity$Outbound = {
  key: string;
  instance_id: string;
};

/** @internal */
export const DeactivateLicenseRequestEntity$outboundSchema: z.ZodType<
  DeactivateLicenseRequestEntity$Outbound,
  z.ZodTypeDef,
  DeactivateLicenseRequestEntity
> = z.object({
  key: z.string(),
  instanceId: z.string(),
}).transform((v) => {
  return remap$(v, {
    instanceId: "instance_id",
  });
});

export function deactivateLicenseRequestEntityToJSON(
  deactivateLicenseRequestEntity: DeactivateLicenseRequestEntity,
): string {
  return JSON.stringify(
    DeactivateLicenseRequestEntity$outboundSchema.parse(
      deactivateLicenseRequestEntity,
    ),
  );
}
export function deactivateLicenseRequestEntityFromJSON(
  jsonString: string,
): SafeParseResult<DeactivateLicenseRequestEntity, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeactivateLicenseRequestEntity$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeactivateLicenseRequestEntity' from JSON`,
  );
}
